import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Blog from './blog';
import ImportantUserDetails from './important-user-details';
import SupplementCategories from './supplement-categories';
import Supplements from './supplements';
import PlanCategory from './plan-category';
import Plans from './plans';
import TransactionDetails from './transaction-details';
import ProductDeliveryStatus from './product-delivery-status';
import UserPurchasedPlans from './user-purchased-plans';
import UserPurchasedSupplements from './user-purchased-supplements';
/* jhipster-needle-add-route-import - JHipster will add routes here */

export default () => {
  return (
    <div>
      <ErrorBoundaryRoutes>
        {/* prettier-ignore */}

        <Route path="blog/*" element={<Blog />} />
        <Route path="important-user-details/*" element={<ImportantUserDetails />} />
        <Route path="supplement-categories/*" element={<SupplementCategories />} />
        <Route path="supplements/*" element={<Supplements />} />
        <Route path="plan-category/*" element={<PlanCategory />} />
        <Route path="plans/*" element={<Plans />} />
        <Route path="transaction-details/*" element={<TransactionDetails />} />
        <Route path="product-delivery-status/*" element={<ProductDeliveryStatus />} />
        <Route path="user-purchased-plans/*" element={<UserPurchasedPlans />} />
        <Route path="user-purchased-supplements/*" element={<UserPurchasedSupplements />} />
        {/* jhipster-needle-add-route-path - JHipster will add routes here */}
      </ErrorBoundaryRoutes>
    </div>
  );
};
